// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".role-container-form .form-title {\n  font-size: 1.3rem;\n  text-transform: uppercase;\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: .5rem;\n  margin-bottom: .5rem;\n  flex-grow: 1; }\n  .role-container-form .form-title::after {\n    content: \"\";\n    flex: 1;\n    height: 0;\n    border-bottom: 1px solid var(--gray-300); }\n", ""]);
// Exports
module.exports = exports;
